<template>
  <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 20 : 734" class="pb-1"
          :style="$isMobile ? 'background: #F8F5FD;border: none':''">
    <div v-if="$isMobile">
      <div class="pa-2 rounded">
        <v-img
          :src="require('chinese' === language ? '@/assets/images/itsm-banner.png' : '@/assets/images/incident-ticket-banner.png')"></v-img>
      </div>
      <div class="d-flex justify-center align-center flex-column mx-4 mt-n2 mb-2 rounded-lg rounded-t-0" style="background: white">
        <img style="width: 100px" class="mt-4" :src="require('@/assets/images/icon-create-error.png')">
        <div class="my-1 font-weight-bold" style="color: #342D39;font-size: 18px;">{{ language === 'chinese' ? '创建失败' : 'Submission failed !'}}</div>
        <div class="mb-4 mt-2" style="color: #333333; font-size: 14px;">很抱歉，您的IT事件工单创建失败</div>
      </div>
    </div>
    <div v-else>
      <v-card-title>
<!--        <v-img max-width="48" max-height="48" :src="require('@/assets/images/icon-成功.png')"></v-img>-->
        <span
          style="color: #A200FF">{{ language === 'chinese' ? '工单创建失败通知！' : 'Submission failed !'
          }}</span>
      </v-card-title>
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    language: {
      type: String,
      default: 'chinese',
    },
    title: {
      type: String,
      default: '工单创建失败通知',
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {}
  },
  mounted() {
  },
}
</script>
